export default __webpack_public_path__ + "static/image-62-0705f7edfe83f2709a64044cad52955d.jpg";